import { Card, CardContent } from "@/components/ui/card";
import { Users, Smartphone, Wrench } from "lucide-react";

const proofs = [
  { icon: Users, text: "Designed based on real teacher needs" },
  { icon: Wrench, text: "Simple tools that solve daily problems" },
  { icon: Smartphone, text: "Works smoothly on mobile phones" },
];

export default function SocialProofSection() {
  return (
    <section data-testid="social-proof-section" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <h2
          data-testid="social-proof-headline"
          className="text-3xl md:text-4xl font-bold text-slate-900 text-center"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Built for Teachers Who Want to <span className="text-green-700">Save Time</span>
        </h2>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
          {proofs.map((item, i) => (
            <Card
              key={i}
              data-testid={`social-proof-card-${i}`}
              className="bg-white border border-slate-100 shadow-sm text-center"
            >
              <CardContent className="p-6">
                <div className="w-14 h-14 rounded-full bg-green-50 flex items-center justify-center mx-auto mb-4">
                  <item.icon className="w-7 h-7 text-green-700" />
                </div>
                <p className="text-base font-medium text-slate-800">{item.text}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <p className="mt-8 text-center text-slate-600 text-sm md:text-base">
          Thousands of teachers can simplify their work using this app.
        </p>
      </div>
    </section>
  );
}
